import produce from 'immer'
import { combineReducers } from 'redux'
import { fetchPlaybookAsync } from 'shared/store/actions/playbooks'
import { Playbook } from 'shared/typings/playbooks/Playbook'

import { AnyRootAction, createReducer } from 'typesafe-actions'

const byId = createReducer<Record<number, Playbook>, AnyRootAction>({}).handleAction(
  [fetchPlaybookAsync.success],
  (state, { payload }) => {
    return produce(state, (draft) => {
      draft[payload.id] = payload
    })
  }
)

export default combineReducers({
  byId,
})
